import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const MaxFeePerGasPropsSchema = z.object({
  getMaxFeePerGas: z.instanceof(HexNumber),
})

type MaxFeePerGasProps = z.infer<typeof MaxFeePerGasPropsSchema>

export class MaxFeePerGas extends ValueObject<MaxFeePerGasProps> {
  /**
   * @returns A BigNumber.
   */
  public getValue(): string {
    return this.props.getMaxFeePerGas.getValue()
  }

  public static create(getMaxFeePerGas: HexNumber): MaxFeePerGas {
    const validatedProps = MaxFeePerGasPropsSchema.parse({ getMaxFeePerGas })
    return new MaxFeePerGas(validatedProps)
  }
}
